import React from "react";
import Card from "react-bootstrap/Card";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "left" }}>
            <br />I am a Final Year Student B.E. specialized in <span className="purple">Computer Engineering</span> from Thapar Institute of Engineering and Technology.
            <br />
            <br />
            I like to play with websites and giving them an immersive look, using 3D libraries with creative features.
            <br />
            <br />
            Apart from web development, <br />I am also interested in:
          </p>
          <ul>
          <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Travelling
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> UX Design
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Software Engineering
            </li>
          </ul>
          <br />
          <br />
          
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
